export const GetPoolList=(activestatus,locationId)=>{
 return  $.get('Pool/GetMinPoolDetails?locationId='+locationId+'&isActive='+activestatus)
}
export const CreatePool=(pool)=>{
    return $.post('Location/AddLocationNPool',pool)
    }
export const UpdatePool=(pool)=>{
    return $.post('Pool/UpdatePool',pool)
}
export const DeletePool=(poolId)=>{
    return $.post('Pool/DeletePool?poolId='+poolId)
}
export const ChangePoolstatus=(poolId,activeStatus)=>{
    return $.post('Pool/PoolStatusChange?poolId='+poolId+'&activeStatus='+activeStatus)
}

export const GetLocationlist=(status)=>{
    return $.get('Location/GetMinLocationDetails?IsActive='+status)
}
export const GetPoolTypes=()=>{
    return $.get('Pool/GetPoolTypes')
}




// WEBPACK FOOTER //
// ./src/pages/Administration/ManagePools/ManagePools.services.js